import React, { useRef } from 'react';
import { ErrorMessage, Field, Form, Formik } from 'formik';
import { TextField } from '@material-ui/core';
import { t } from 'i18next';
import { useCustomer } from 'hooks/useCustomer';
import { useNavigate } from 'react-router-dom';
import { getRoutesUri } from 'services/generic';

import { validationSchema } from 'schemas/SignInWithNClientErrors';
import Button from 'components/UI/Buttons/Button/Button';
import ScrollToFieldError from 'components/Common/Formik/ScrollToFieldError/ScrollToFieldError';
import TurnstileFormikRow, {
  TurnstileRef,
} from 'components/Common/Cloudflare/TurnstileFormikRow';

import styles from './LoginWithName.module.scss';

const initValues = { surname: '', nClient: '', turnstileToken: '' };

export default function LoginWithName(): JSX.Element {
  const { login } = useCustomer();
  const navigate = useNavigate();
  const turnstile = useRef<TurnstileRef>();
  const fields = [
    {
      label: t('LABEL_SURNAME'),
      name: 'surname',
    },
    {
      label: t('LABEL_CLIENT_NUMBER'),
      name: 'nClient',
    },
  ];

  async function onSubmit(values: typeof initValues) {
    const response = await login(values);

    if (response.statusCode === 200) {
      localStorage.setItem('user_login_type', 'compte');
      navigate(getRoutesUri('customerAccountOrderHistory') as string);

      return;
    }

    turnstile.current?.reset();
  }

  return (
    <Formik
      initialValues={initValues}
      validationSchema={validationSchema}
      onSubmit={onSubmit}
    >
      {({ errors, touched }) => (
        <Form noValidate>
          <div className={styles.container}>
            <label className={styles.labelDesktop}>
              <span>{t('LABEL_ALREADY_ORDERED')}</span>
            </label>
            <div className={styles.fields}>
              {fields.map(field => {
                const { label, name } = field;

                return (
                  <div className={styles.field} key={name}>
                    <div className={styles.labelTextField}>
                      <label>
                        {label}
                        <span>*</span>
                      </label>
                    </div>
                    <Field
                      as={TextField}
                      variant="outlined"
                      name={name}
                      error={errors[name] && touched[name]}
                      helperText={<ErrorMessage name={name} />}
                      required
                      size="small"
                    />
                  </div>
                );
              })}
              <TurnstileFormikRow
                turnstileRef={turnstile}
                turnstileProps={{ options: { action: 'login_admin' } }}
              />
            </div>
            <div className={styles.actionsToolBar}>
              <div className={styles.button}>
                <Button type={'submit'} model={'primary'}>
                  {t('LABEL_SIGNIN_BUTTON')}
                </Button>
              </div>
            </div>
          </div>
          <ScrollToFieldError />
        </Form>
      )}
    </Formik>
  );
}
